import React, {useEffect, useState} from 'react';
import {checkoutCart, checkoutTransaction, getResourceFile} from '../../network';
import {formatPrice} from '../../helpers/Helper';
import styled from '@emotion/styled';
import {connect} from 'react-redux';
import {Link, useHistory} from 'react-router-dom';
import {setCart} from '../../redux/actions/CartActions';
import {keyframes} from '@emotion/core';
// import {PaymentGateway} from '@howarded/react-sms-pg';
import {PaymentGateway} from './PaymentGateway/PaymentGateway';
//import {transactionStates} from '@howarded/react-sms-pg';
import {merchantKey} from '../../utils/mockAuthPG';

const FadeIn = keyframes`
 from, 0%, to {
    opacity:0;
    bottom:0rem
  }
80%{
    opacity:0.5;
    bottom: 1rem;
}
  100%{
    opacity:1;
    bottom:3rem;
  }

`;

const MobileFadeIn = keyframes`
 from, 0%, to {
    opacity:0;
    bottom: -45rem
  }
80%{
    opacity:0.5;
    bottom: -40rem;
}
  100%{
    opacity:1;
    bottom:-37rem;
  }

`;
const SmallMobileFadeIn = keyframes`
 from, 0%, to {
    opacity:0;
    bottom: 0rem
  }
80%{
    opacity:0.5;
    bottom: 1rem;
}
  100%{
    opacity:1;
    bottom: 2rem;
  }

`;

const PaymentContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: var(--space-32) var(--space-32);
    position: absolute;

    /* default/shade/white */
    z-index:99999999999;
    background: #FFFFFF;
    box-shadow: 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035), 0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275), 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198), 0px 100px 80px rgba(0, 0, 0, 0.07);
    border-radius: var(--space-12);
    animation: ${FadeIn} 0.5s linear;
    
    *,
    div,
    > *,
    div > * {
        box-sizing: border-box;
        overscroll-behavior: none;
        outline: none;

        &:focus {
            box-shadow: 0 0 0 var(--space-4) var(--color-blue-300);
            border-radius: 0.2rem;
        }
    }
`;

export const ConfirmationContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: var(--space-32) var(--space-32);
    position: absolute;
    bottom: 3rem;
    width: inherit;
    align-items: center;

    /* default/shade/white */
    z-index:99999999999;
    background: #FFFFFF;
    box-shadow: 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035), 0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275), 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198), 0px 100px 80px rgba(0, 0, 0, 0.07);
    border-radius: var(--space-12);
    animation: ${FadeIn} 0.5s linear;

    h1{
        
        margin-bottom:2rem;
        text-align:left;
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--font-20);
        line-height: var(--space-22);
        /* identical to box height, or 100% */
        
        
        /* default/gray/800 */
        
        color: #353B40;
    }

    h2{
       
        font-family:Inter,sans-serif;
        font-size:var(--font-18);
        font-style:normal;
        font-weight:500;
    }
    div{
        
        margin-top:2rem;
        display:flex;
        flex-direction:row;
        width:20rem;
        justify-content:space-between;
    }
    button{
        background-color:var(--color-white);
        font-family:Inter,sans-serif;
        font-weight:500;
        font-style:normal;
        font-size:var(--font-20);
        color:var(--color-gray-600);
    }
    .yes{
        display: flex;
        flex-direction: row;
        padding: var(--space-12) var(--space-56);

        width: 6.75rem;
        height: var(--space-40);

        /* Company Dark */

        background: #049CBE;
        border-radius: 6px;
        color:var(--color-white);
    }
    .no{
        display: flex;
        flex-direction: row;
        padding: var(--space-12) var(--space-56);
        
        width: 6.75rem;
        height: var(--space-40);
        
        /* Company Dark */
        border: 1px solid var(--color-gray-700);
        background-color:var(--color-white);
        border-radius: var(--space-6);
        color:var(--color-gray-700);
    }

    /* @media (max-width: 800px){
        left: 11rem;
        bottom: -37rem;
        animation: ${MobileFadeIn} 0.5s linear;
    }
    @media (max-width: 500px){
        transform:scale(0.8);
        left: 0;
        bottom: 2rem;
        animation: ${SmallMobileFadeIn} 0.5s linear;
    } */
`;

const ConfirmationComponent = ({auth, setCustomerCart, price, confirm, setConfirm, hasInsurance}) => {
    // const [hasInsurance, setHasInsurance] = useState(false);
    const [cart, setCart] = useState([]);
    const [currency, setCurrency] = useState('jmd');

    const [customQuantityIndex, setCustomQuantityIndex] = useState(-1);
    const [lineItemQuantities, setLineItemQuantities] = useState({});
    const [instantUpdateQuantities, setInstantUpdateQuantities] = useState({});
    const history = useHistory();

    const handleCartCheckout = () => {
        checkoutCart(auth.customer_id, auth.token, {has_insurance: hasInsurance})
            .then(result => {
                // setSummary({
                //     originalPrice: result.totalOriginalPrice,
                //     saleDeduction: result.totalSaleDeduction,
                //     subTotal: result.totalSubTotal,
                //     estTax: result.totalTax,
                //     orderTotal: result.cartTotal,
                // });
                // setCart([...result.variants]);
                // setCustomQuantityIndex(-1);

                setCustomerCart({});

                // retrieveCustomerCart();
                history.push(`/order-confirmation/${result._id}`);
            })
            .catch(error => console.error(error));
    };

    const handleFormSubmit = (fields, {setTransactionStatus, setFormSubmitting, setError}) => {
        const {cardNumber, expiryMonth, expiryYear, cardCVC} = fields;
        const card = {
            number: cardNumber,
            expiryDate: `${expiryMonth}${expiryYear}`,
            cvv: cardCVC
        };

        const params = {
            card,
            currency,
            amount: price,
            merchant_key: merchantKey,
        };

        setFormSubmitting(true);

        return setTimeout(async () => {
            try {
                const response = await checkoutTransaction(params);
                //setTransactionStatus(transactionStates.SUCCESS);
                setTransactionStatus("SUCCESS");
                setTimeout(() => {
                    handleCartCheckout();
                }, 1000);
            } catch (error) {
                setFormSubmitting(false);
                if (error.response) {
                    switch (error.response.status) {
                        case 401:
                            setError('Unauthorized');
                            break;
                        case 422: {
                            let errorMessage = null;
                            if (error.response.data.errors) errorMessage = `${error.response.data.errors[0].msg}. ${error.response.data.errors[0].param}`;
                            if (error.response.data.error) errorMessage = `${error.response.data.error}`;

                            setError(`Invalid Request.${errorMessage ? ` ${errorMessage}` : ''}`);
                            break;
                        }
                        case 503:
                            setError('Service Unavailable.');
                            break;
                        default:
                            break;
                    }
                } else setError('Unknown error occurred. Server response not received');
            }
        }, 1500);
    };

    return (
        // <PaymentContainer style={{
        //     display: confirm,
        //     bottom: '2.25rem',
        //     right: '0',
        //     width: 'max-content'
        // }}>
        //     <PaymentGateway price={price} onFormSubmit={handleFormSubmit}/>
        // </PaymentContainer>

        <ConfirmationContainer style={{display:confirm}}>
            <h1>Confirmation</h1>
            <h2>Are you sure you want to complete this order?</h2>
            <div>
                <button className="yes" onClick={() => handleCartCheckout()}>Yes</button>
                <button className="no" onClick={() => setConfirm(false)}>No</button>
            </div>
        </ConfirmationContainer>
    );
};

const mapStateToProps = (state, props) => ({
    auth: state.auth,
    cart: state.cart,
    confirm: props.confirm,
    setConfirm: props.setConfirm,
    hasInsurance: props.hasInsurance
});
const mapDispatchToProps = {
    setCustomerCart: setCart
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationComponent);
